import { ButtonBrandVariant, ButtonSize, ButtonType, ButtonVariant } from './button.types';

export const DEFAULT_BUTTON_SIZE: ButtonSize = 'l';
export const DEFAULT_BUTTON_TYPE: ButtonType = 'button';
export const BUTTON_VARIANT_BRAND: ButtonVariant = 'brand';

export const BUTTON_SIZES: Array<ButtonSize> = ['s', 'm', 'l'];
export const BUTTON_VARIANTS: Array<ButtonVariant> = ['primary', 'secondary', 'tertiary', 'translucent', 'destructive', 'brand'];

export const BRAND_NAMES: Array<ButtonBrandVariant> = ['amg', 'maybach', 'mercedes-benz'];

